<h4>Supported</h4>
<div class="support-container">
    @if ($data().three) {
        <span class="text-success"><i class="far fa-check-circle"></i> Web</span>
    } @else {
        <span class="text-error"><i class="far fa-xmark-circle"></i> Web </span>
    }
    @if ($data().cycles) {
        <span class="text-success"><i class="far fa-check-circle"></i> Path-traced</span>
    } @else {
        <span class="text-error"><i class="far fa-xmark-circle"></i> Path-traced</span>
    }
</div>
